export default __webpack_public_path__ + "static/media/minus.8e783813.svg";